import React, { Component } from 'react';
import  MyMenu  from './mymenu';
import { Row, Col,Jumbotron } from 'reactstrap';

class Header extends Component {
    render() {
        return (
            <Row>
                <Col>
                    <br/>
                <MyMenu user={this.props.user} />
                    <br/>
                    <Jumbotron>
                        <br/>
                        <h1 className="display-3">Robo Shop</h1>
                        <p className="lead">We sell the latest Robots in the world. We Gurantee that they will do their jobs as you tell them.</p>
                        <br/><br/>
                    </Jumbotron>
                </Col>
            </Row>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/header.js